// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const getUserLastConnection = async () => {
  return privateRequest.get(ConfEnv.API_URL.URL_GET_USER_LAST_CONNECTION);
};
